import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddleTomorrowGoalsHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'

type GoalsForTomorrowCardProps = {
  goals: HuddleDashboard['tomorrowGoalsApi']
  className?: string
}

export function GoalsForTomorrowCard({
  goals,
  className = 'dashboard-huddle-yesterday-card dashboard-huddle-full-row dashboard-huddle-tomorrow-goals-row',
}: GoalsForTomorrowCardProps): React.ReactElement {
  const { goalMetrics, loading, data } = goals
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleTomorrowGoalsHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Goals for tomorrow"
      showTitleChevron={false}
      className={className}
      loading={pending}
      skeleton={{ metrics: 3, metricColumns: 3 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={goalMetrics} />
    </DashboardSectionCard>
  )
}
